export default __webpack_public_path__ + "locales/pl/Webhooks.json?hash=89a0b267f1b4d5d970b1df188bfedac3";